import {
  Box,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const ApprovalBtn = (props: any) => {
  const {
    selected = false,
    onBtnClick,
    icon = null,
    label = "custom",
    boxSx = {},
    iconStyle = {},
    userConfigLoading,
  } = props;
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      onClick={onBtnClick}
      sx={{
        cursor: "pointer",
        display: "flex",
        border: `1px solid ${selected ? "#6E8C20" : "#E2E2E2"}`,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        backgroundColor: selected ? "#E1FFA2" : "#fff",
        borderRadius: "5px",
        minWidth: isMobileView ? "135px" : "192px",
        minHeight: "50px",
        ...(selected && { boxShadow: `0px 3px 6px 0px rgba(37, 51, 75, 0.1)` }),
        ...boxSx,
      }}
    >
      {icon &&
        (userConfigLoading ? (
          <Skeleton height="25px" width={"25px"} variant="circular" />
        ) : (
          <img
            alt=""
            src={icon}
            style={{ width: "24px", height: "24px", ...iconStyle }}
          />
        ))}
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 500,
          //   lineHeight: "18.15px",
          fontFamily: "Inter",
        }}
      >
        {userConfigLoading ? (
          <Skeleton width={isMobileView ? "60px" : "120px"} variant="text" />
        ) : (
          label
        )}
      </Typography>
    </Box>
  );
};

export default ApprovalBtn;
